<template>
  <div class="profile">
    <ModalUbahData ref="modalubahprofile" @action="changeProfile"></ModalUbahData>
    <modalPassword ref="modalPassword" @action="changePassword"></modalPassword>
    <modalMobilephone ref="modalMobilephone" @action="changeMobilephone"></modalMobilephone>
    <modalEmail ref="modalEmail" @action="changeEmail"></modalEmail>
    <v-col class="pt-5">
      <div>
        <v-row>
          <v-col cols="12" md="3" class="py-0 pr-md-0">
            <profile-menu></profile-menu>
          </v-col>
          <v-col cols="12" md="9" class="pl-md-5 py-0 mt-5 mt-md-0">
            <div>
              <v-row>
                <v-col md="12" class="py-0">
                  <v-card outlined elevation="0" class="py-3">
                    <!-- <div class="px-3">
											<v-tabs color="#222" class="no-slider">
												<v-tab class="text-body-2 text-capitalize" @click="showAccountInfo">Akun</v-tab>
												<v-tab class="text-body-2 text-capitalize" @click="showAddressInfo">Daftar Alamat</v-tab>
												<v-tab class="text-body-2 text-capitalize" v-if="false">Pesan</v-tab>
											</v-tabs>
                    </div>-->
                    <div class="px-3 py-2" v-if="accountInfo">
                      <v-row class="d-flex flex-row-reverse">
                        <v-col cols="12" md="3">
                          <v-row>
                            <v-col cols="12" sm="6" md="12" class="py-0 text-center">
                              <!-- <v-img height="200" class="rounded-lg" :src="detailProfile.user_image ? detailProfile.user_image : '/assets/icons/default-toko.svg'"></v-img> -->
                              <v-img v-if="detailProfile.user_image" width="50" height="50" class="mx-auto rounded-circle"
                                :src="detailProfile.user_image
                                    ? detailProfile.user_image
                                    : '/assets/icons/default-toko.svg'
                                  "></v-img>
                              <v-avatar v-else color="black" size="200">
                                <v-icon dark size="200">mdi-account-circle</v-icon>
                              </v-avatar>
                            </v-col>
                            <v-col cols="12" sm="6" md="12" class="py-0 pl-0 pl-md-3 my-auto">
                              <v-file-input v-show="false" accept="image/*" id="inputImage" v-model="imgUpload"
                                @change="handleFileUpload($event)" truncate-length="50" small-chips outlined dense
                                hide-details="auto" prepend-icon :clearable="false" placeholder="GANTI FOTO"
                                class="mt-md-3 text-body-2 rounded-lg file-button"></v-file-input>
                              <v-btn outlined  class="px-0 mt-3 text-body-2 rounded-lg btn-primary-outline" block
                                :loading="loadingProcess" @click="openUpload">Ubah Foto</v-btn>
                              <v-btn outlined  class="px-0 mt-3 text-body-2 rounded-lg btn-warning-outline" block
                                @click="showModalPassword">Ubah Password</v-btn>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="12" md="9" class="text-body-2">
                          <div class="d-flex">
                            <div class="pr-5 font-weight-bold">Data Diri</div>
                            <!-- <div class="primary--text cursor-pointer" @click="editName"><v-icon color="primary">{{'mdi-pencil'}}</v-icon></div> -->
                          </div>
                          <div class="pt-5">
                            <v-row>
                              <v-col cols="5" md="3" class="pt-0">Nama</v-col>
                              <v-col cols="7" md="9" class="pl-0 pt-0 font-weight-bold">
                                <span class="mr-4">{{ detailProfile.user_name }}</span>
                                <span class="primary--text cursor-pointer" @click="ubahData('user_name', detailProfile)"
                                  v-if="!loadingProfile">
                                  <v-icon color="primary">{{ "mdi-pencil" }}</v-icon>
                                </span>
                                <span v-else>
                                  <v-progress-circular indeterminate color="green" :size="18"></v-progress-circular>
                                </span>
                              </v-col>
                              <v-col cols="5" md="3" class="pt-0">Tanggal Lahir</v-col>
                              <v-col cols="7" md="9" class="pl-0 pt-0 font-weight-bold">
                                <span class="mr-4">
                                  {{
                                    detailProfile.user_birthdate &&
                                    detailProfile.user_birthdate != "0000-00-00"
                                    ? `${$options.filters.tanggal(detailProfile.user_birthdate)}`
                                    : "Belum ada data"
                                  }}
                                </span>
                                <span class="primary--text cursor-pointer"
                                  @click="ubahData('user_birthdate', detailProfile)" v-if="!loadingProfile">
                                  <v-icon color="primary">{{ "mdi-pencil" }}</v-icon>
                                </span>
                                <span v-else>
                                  <v-progress-circular indeterminate color="green" :size="18"></v-progress-circular>
                                </span>
                              </v-col>
                              <v-col cols="5" md="3" class="pt-0">Jenis Kelamin</v-col>
                              <v-col cols="7" md="9" class="pl-0 pt-0 font-weight-bold">
                                <span class="mr-4">{{ detailProfile.user_gender }}</span>
                                <span class="primary--text cursor-pointer" @click="ubahData('user_gender', detailProfile)"
                                  v-if="!loadingProfile">
                                  <v-icon color="primary">{{ "mdi-pencil" }}</v-icon>
                                </span>
                                <span v-else>
                                  <v-progress-circular indeterminate color="green" :size="18"></v-progress-circular>
                                </span>
                              </v-col>
                              <v-col v-if="detailProfile.user_network_id > 0" cols="5" md="3" class="pt-0">Kode
                                Referal</v-col>
                              <v-col v-if="detailProfile.user_network_id > 0" cols="7" md="9"
                                class="pl-0 pt-0 font-weight-bold">
                                <span class="mr-4">
                                  {{
                                    getUrlReferal(detailProfile.user_username)
                                  }}
                                </span>
                                <input type="hidden" :value="getUrlReferal(detailProfile.user_username)" id="inputCopy" />
                                <span class="primary--text cursor-pointer text-copy" @click="copyme"
                                  v-if="!loadingProfile">Salin</span>
                                <span v-else>
                                  <v-progress-circular indeterminate color="green" :size="18"></v-progress-circular>
                                </span>
                              </v-col>
                            </v-row>
                          </div>
                          <div class="pt-5 font-weight-bold">Kontak</div>
                          <div class="pt-5">
                            <v-row>
                              <v-col cols="5" md="3" class="pt-0">No. Handphone</v-col>
                              <v-col cols="7" md="9" class="pl-0 pt-0 font-weight-bold">
                                <span class="mr-4">{{ detailProfile.user_mobilephone }}</span>
                                <span class="primary--text cursor-pointer" @click="$refs.modalMobilephone.modalShow()"
                                  v-if="!loadingProfile">
                                  <v-icon color="primary">{{ "mdi-pencil" }}</v-icon>
                                </span>
                                <span v-else>
                                  <v-progress-circular indeterminate color="green" :size="18"></v-progress-circular>
                                </span>
                              </v-col>
                              <v-col cols="5" md="3" class="pt-0">Email</v-col>
                              <v-col cols="7" md="9" class="pl-0 pt-0 font-weight-bold">
                                <span class="mr-4">{{ detailProfile.user_email }}</span>
                                <span class="primary--text cursor-pointer" @click="$refs.modalEmail.modalShow()"
                                  v-if="!loadingProfile">
                                  <v-icon color="primary">{{ "mdi-pencil" }}</v-icon>
                                </span>
                              </v-col>
                            </v-row>
                          </div>
                          <div class="pt-5 font-weight-bold">ID Sponsor</div>
                          <div class="pt-5">
                            <v-row>
                              <v-col cols="5" md="3" class="pt-0">ID Sponsor</v-col>
                              <v-col cols="7" md="9" class="pl-0 pt-0 font-weight-bold">
                                <span class="mr-4">
                                  {{
                                    detailProfile.user_sponsor_user_username
                                    ? detailProfile.user_sponsor_user_username
                                    : "-"
                                  }}
                                </span>
                              </v-col>
                            </v-row>
                          </div>
                        </v-col>
                      </v-row>
                    </div>
                    <!-- <div class="px-3 py-2" v-if="addressInfo">
                      <tab-address></tab-address>
                    </div> -->
                    <div class="px-3 py-2">
                      <tab-address-v2></tab-address-v2>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-col>
  </div>
</template>

<script>
import ProfileMenu from "@/components/layout/store/ProfileMenu";
import ModalUbahData from "@/views/store/profile/ModalUbahData";
import modalPassword from "@/views/store/profile/ModalPassword";
import modalMobilephone from "@/views/store/profile/ModalMobilephone";
import modalEmail from "@/views/store/profile/ModalEmail";
import TabAddress from "@/views/store/profile/TabAddress";
import TabAddressV2 from "@/views/store/profile/TabAddressV2";
import { mapState, mapActions, mapMutations } from "vuex";

export default {
  components: {
    ProfileMenu,
    ModalUbahData,
    modalPassword,
    modalMobilephone,
    TabAddress,
    TabAddressV2,
    modalEmail
  },
  data() {
    return {
      loadingProcess: false,
      loadingProfile: false,
      accountInfo: true,
      addressInfo: false,
      addressInfoV2: false,
      imgUpload: {}
    };
  },
  computed: {
    ...mapState("profile", ["detailProfile", "response"])
  },
  methods: {
    ...mapActions("profile", [
      "editProfile",
      "uploadImage",
      "getProfileDetail",
      "editPassword",
      "editMobilephone",
      "editEmail",
    ]),
    // ...mapActions("address", ["getAddress"]),
    ...mapActions("addressKiriminaja", ["getAddress"]),
    ...mapMutations(["makeAlert"]),

    showAccountInfo() {
      this.accountInfo = true;
      this.addressInfo = false;
      this.addressInfoV2 = false;
    },
    showAddressInfo() {
      this.addressInfo = true;
      this.addressInfoV2 = false;
      this.accountInfo = false;
    },
    showAddressInfoV2() {
      this.addressInfo = false;
      this.addressInfoV2 = true;
      this.accountInfo = false;
    },
    ubahData(type, value) {
      this.$refs.modalubahprofile.modalShow(type, value);
    },
    changeProfile(data) {
      this.loadingProfile = true;
      let params = {
        name: data.user_name,
        birthdate: data.user_birthdate,
        gender: data.user_gender,
        email: data.user_email,
        mobilephone: data.user_mobilephone
      };
      this.editProfile(params)
        .then(() => {
          this.makeAlert({
            code: "success",
            type: "success",
            message: this.response.message,
            show: true
          });
          this.getProfileDetail();
          this.loadingProfile = false;
        })
        .catch(() => {
          this.loadingProfile = false;
        });
    },
    changePassword(params) {
      this.editPassword(params).then(() => {
        this.getProfileDetail();
        this.$refs.modalPassword.modalHide();
      });
    },
    changeMobilephone(params) {
      this.editMobilephone(params).then(() => {
        this.getProfileDetail();
        this.$refs.modalMobilephone.modalHide();
      });
    },
    changeEmail(params) {
      this.editEmail(params).then(() => {
        this.getProfileDetail();
        this.$refs.modalEmail.modalHide();
      });
    },
    async openUpload() {
      const input = await document.getElementById("inputImage");
      input.click();
    },
    handleFileUpload(event) {
      this.loadingProcess = true;
      let formData = new FormData();
      formData.append("image", event);
      this.uploadImage(formData)
        .then(() => {
          this.makeAlert({
            code: "success",
            type: "success",
            message: this.response.message,
            show: true
          });
          this.getProfileDetail();
          this.loadingProcess = false;
        })
        .catch(() => {
          this.loadingProcess = false;
        });
    },
    showModalPassword() {
      this.$refs.modalPassword.modalShow();
    },
    getUrlReferal(network_id) {
      // return process.env.VUE_APP_DOMAIN + "/r/" + network_id;
      return window.location.origin + "/r/" + network_id;
    },
    copyme() {
      var copyText = document.getElementById("inputCopy");
      copyText.setAttribute("type", "text");
      copyText.select();
      try {
        document.execCommand("copy");
        setTimeout(function () {
          setTimeout(function () {
            document.querySelector(".text-copy").innerHTML = "Salin";
          }, 1000);
          document.querySelector(".text-copy").innerHTML = "Tersalin";
        }, 300);
      } catch (err) {
        alert("Oops, tidak dapat menyalin");
      }
      copyText.setAttribute("type", "hidden");
      window.getSelection().removeAllRanges();
    }
  },
  watch: {
    "$route.name": {
      immediate: true,
      handler: function (val) {
        if (val == "address-list") {
          this.showAddressInfo();
        }else{
          this.showAccountInfo();
        }
      }
    }
  },
  created() {
    this.$store.dispatch("setPageTitle", "Profile");
    this.getAddress();
    this.getProfileDetail();
    // editName() {
    // 	this.$refs.modalName.modalShow();
    // }
  }
};
</script>
